import React from 'react';
import { AudioTranscriptionStatus } from '../../hooks/useAudioTranscription';

type PressToTalkButtonProps = {
  disabled?: boolean,
  status: AudioTranscriptionStatus,
  onStart: () => void,
  onStop: () => void,
};

export const PressToTalkButton: React.FC<PressToTalkButtonProps> = ({
  disabled = false,
  status,
  onStart,
  onStop,
}) => {
  const isRecording = status === 'recording';
  const isTranscribing = status === 'transcribing';
  const label = disabled
    ? '当前设备浏览器不支持录音'
    : isRecording
      ? '点击停止录音'
      : isTranscribing
        ? '语音转写中'
        : '点击开始录音';

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      disabled={disabled || isTranscribing}
      onClick={() => {
        if (disabled || isTranscribing) {
          return;
        }

        if (isRecording) {
          onStop();
          return;
        }

        onStart();
      }}
      className={`flex h-12 w-12 items-center justify-center rounded-full border transition ${
        disabled
          ? 'cursor-not-allowed border-gray-200 bg-gray-100 text-gray-400'
          : isRecording
            ? 'border-red-500 bg-red-500 text-white shadow-[0_0_0_6px_rgba(239,68,68,0.14)]'
            : isTranscribing
              ? 'cursor-wait border-amber-200 bg-amber-100 text-amber-700'
              : 'border-gray-200 bg-white text-gray-600 hover:border-indigo-300 hover:bg-indigo-50 hover:text-indigo-600'
      }`}
    >
      {isTranscribing ? (
        <svg
          viewBox="0 0 24 24"
          className="h-5 w-5 animate-spin"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M21 12a9 9 0 1 1-6.22-8.56" />
        </svg>
      ) : (
        <svg
          viewBox="0 0 24 24"
          className={`h-5 w-5 ${isRecording ? 'scale-110' : ''}`}
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M12 3a3 3 0 0 1 3 3v6a3 3 0 1 1-6 0V6a3 3 0 0 1 3-3Z" />
          <path d="M19 11a7 7 0 0 1-14 0" />
          <path d="M12 18v3" />
          <path d="M8 21h8" />
        </svg>
      )}
    </button>
  );
};
